import React from "react";
import { Link } from "react-router-dom";
import { useAppState } from "../state/AppStateContext";
import { t } from "../i18n/strings";

export default function NotFoundScreen() {
  const { lang } = useAppState();
  return <section style={styles.screen}><h1>{t(lang, "notFoundTitle")}</h1><p>{t(lang, "notFoundBody")}</p><Link className="btn btn-primary" to="/">{t(lang, "backToCheck")}</Link></section>;
}
const styles = { screen: { padding: "70px 20px", textAlign: "center" } };
